// How settled an issued invoice is. The invoice itself never changes; this is derived from what happened to it since.
//   paid     = net payments applied (money later moved back to customer credit counts as not paid)
//   credited = credit notes issued against it
// A credit note is not a payment: an invoice credited in full is "Credited", never "Paid".
export type InvoiceSettlement = "void" | "unpaid" | "part_paid" | "part_credited" | "paid" | "credited";

export function invoiceSettlement(i: { status: string; totalPence: number; paidPence: number; creditedPence: number }): InvoiceSettlement {
  if (i.status === "void") return "void";
  if (i.creditedPence >= i.totalPence) return "credited";
  const outstanding = i.totalPence - i.paidPence - i.creditedPence;
  if (outstanding <= 0) return "paid";
  if (i.paidPence > 0) return "part_paid";
  if (i.creditedPence > 0) return "part_credited";
  return "unpaid";
}

export const INVOICE_SETTLEMENT_LABEL: Record<InvoiceSettlement, string> = {
  void: "Void", unpaid: "Unpaid", part_paid: "Part paid", part_credited: "Part credited", paid: "Paid", credited: "Credited",
};
